import {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  nextPage,
  previousPage,
  selectExpertiseQuestions,
  questionAnswered,
  selectPage,
  resetPage,
  selectExpertiseComplete
} from "../features/expertise/expertiseSlice.js";
import expertiseIcon from "../assets/Navigation/nav_icon_expertise_green.png";
import SideNav from "../components/SideNav";
import PageTitle from "../components/PageTitle";
import { Link } from "react-router-dom";
import SlideOut from "../components/SlideOut.js";
import halfStat from '../assets/Popups/popup_industry_stat_1-2.png'
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Button, Container } from "@mui/material";

const Expertise = () => {
  const page = useSelector(selectPage);
  const expertiseQuestions = useSelector(selectExpertiseQuestions)
  const dispatch = useDispatch();
  const section = {
    title: "Disponibilidad de conocimientos técnicos",
    icon: expertiseIcon,
    pages: [1, 2, 3],
  };
  
  const isComplete = useSelector(selectExpertiseComplete)
  useEffect(
    ()=>!isComplete ? dispatch(resetPage()):null,[]
  )

  const calcWellAverage = () => {
    switch (expertiseQuestions[1].answer) {
      case '<10':
        return 5;
      case '10-50':
        return 30;
      case '50-100':
        return 75;
      case '100-1000':
        return 550;
      case '1000+':
        return 1000;
      default:
        return 0
                }
              }

  const calcYield = (engineers) =>{
    let wells = calcWellAverage()
    let wellYield = wells/engineers
    if(wellYield < 1 || wellYield > 100) {
      return 1
    } else if ( wellYield >= 1 && wellYield < 10){
      return 2
    } else if ( wellYield >= 10 && wellYield < 25){
      return 3
    } else if (wellYield >= 25 && wellYield <= 100){
      return 2
    }
  }

  const personnelChallenges = {
    title: 'Superar los retos del personal de campo',
    copy: 'El uso del caudalímetro multifásico (MPFM) Roxar 2600 puede ayudar a su operación a superar los retos del personal de campo con:',
    bullets: [<li>Acceso remoto a datos procesables</li>, <li>Mayor cobertura/pozos por operador (mayor productividad y eficiencia)</li>, <li>Menor riesgo de HSE con menos visitas al campo (especialmente con personal sin experiencia)</li>]
  }

  const increaseExperience = {
    title:'Aumentar la reserva de experiencia',
    copy:'El uso del caudalímetro multifásico (MPFM) Roxar 2600 puede ayudar a su operación a aprovechar la experiencia con la capacidad de colaborar en los problemas. Asimismo, aumenta el conjunto de experiencias mediante el análisis a distancia y la resolución compartida de problemas a través del análisis con apoyo de Emerson.',
    stat:{
      copy:'Más de la mitad de los ingenieros de campo encuestados tienen menos de dos años de experiencia.*',
      graphic: halfStat
    }
  }

  return (
    <Container className="content_container" maxWidth='lg'>
    <div className="roxar_content">
      <div className="main_content">
        <PageTitle section={section} currentPage={page} />
        <div className="page_contents">
          {page === 1 && (
            <div className="challenges">
              <div>
                <h1>Desafíos de producción</h1>
                <ul>
                  <li>
                  Limitación de la disponibilidad de personal de campo
                  </li>
                  <li>
                  Falta de experiencia (técnica y de seguridad)
                  </li>
                </ul>
              </div>
              <div className="solution_copy">
                <p>
                ¿La gestión de demasiados pozos está agotando a sus ingenieros de campo? El caudalímetro multifásico (MPFM) Roxar 2600 aumenta el número de pozos que puede cubrir cada ingeniero, aumentando la productividad y reduciendo los costos. 
                </p>
                <Button className="forward_button production_button" onClick={() => dispatch(nextPage())}>Aprenda cómo</Button>
              </div>
            </div>
          )}
          {page === 2 && (
            <div className="questions">
              <div>
                  <h3 className="question">P: ¿Cuántos pozos puede visitar un ingeniero de campo al día?</h3>
                  <div className="answers">
                      <Button className={`answer ${expertiseQuestions[0].answer=='1'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'1', score:1, max: 4}))}> 1 </Button>
                      <Button className={`answer ${expertiseQuestions[0].answer=='2-5'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'2-5', score:2, max: 4}))}> 2-5</Button>
                      <Button className={`answer ${expertiseQuestions[0].answer=='6-10'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'6-10', score:3, max: 4}))}> 6-10</Button>
                      <Button className={`answer ${expertiseQuestions[0].answer=='Más de 11'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'Más de 11', score:4, max: 4}))}>Más de 11</Button>
                  </div>
              </div>
              <div>
                  <h3 className="question">P: ¿Cuántos pozos explota actualmente?</h3>
                  <div className="answers">
                      <Button className={`answer ${expertiseQuestions[1].answer=='Menos de 10'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'Menos de 10', score:1, max: 5}))}>Menos de 10</Button>
                      <Button className={`answer ${expertiseQuestions[1].answer=='De 10 a 50'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'De 10 a 50', score:2, max: 5}))}> De 10 a 50 </Button>
                      <Button className={`answer ${expertiseQuestions[1].answer=='De 50 a 100'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'De 50 a 100', score:3, max: 5}))}>De 50 a 100</Button>
                      <Button className={`answer ${expertiseQuestions[1].answer=='De 100 a 1000'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'De 100 a 1000', score:4, max: 5}))}> De 100 a 1000</Button>
                      <Button className={`answer ${expertiseQuestions[1].answer=='Más de 1000'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'Más de 1000', score:5, max: 5}))}> Más de 1000 </Button>
                  </div>
              </div>
              <div>
                  <h3 className="question">P: ¿Puede acceder y controlar su sitio de pozos a distancia hoy en día?</h3>
                  <div className="answers">
                      <Button className={`answer ${expertiseQuestions[2].answer=='Sí'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'Sí', score:4, max: 4}))}> Sí</Button>
                      <Button className={`answer ${expertiseQuestions[2].answer=='No'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'No', score:2, max: 4}))}> No </Button>
                      
                  </div>
              </div>
              <div className="page_nav">
              <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Anterior</span></Button>
                  <Button className="next_button" onClick={() => dispatch(nextPage())}><span>Siguiente</span><ArrowForwardIos /></Button>
              </div>
            </div>
          )}
          {page === 3 && (
              <div className="questions">
              <div>
                  <h3 className="question">P: ¿Cuál es la experiencia media (años) de sus ingenieros de campo?</h3>
                  <div className="answers">
                  <Button className={`answer ${expertiseQuestions[3].answer=='De 0 a 6 meses'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'De 0 a 6 meses', score:1, max: 3}))}> De 0 a 6 meses</Button>
                  <Button className={`answer ${expertiseQuestions[3].answer=='De 6 meses a 2 años'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'De 6 meses a 2 años', score:2, max: 3}))}> De 6 meses a 2 años</Button>
                  <Button className={`answer ${expertiseQuestions[3].answer=='De 2 a 5 años'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'De 2 a 5 años', score:3, max: 3}))}> De 2 a 5 años</Button>
                  <Button className={`answer ${expertiseQuestions[3].answer=='De 5 a 15 años'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'De 5 a 15 años', score:2, max: 3}))}>De 5 a 15 años</Button>   
                  <Button className={`answer ${expertiseQuestions[3].answer=='Más de 15 años'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'Más de 15 años', score:1, max: 3}))}>Más de 15 años</Button>   
                  </div>
              </div>
              <div>
                  <h3 className="question">P: ¿La experiencia media de sus ingenieros de campo está aumentando o disminuyendo?</h3>
                  <div className="answers">
                  <Button className={`answer ${expertiseQuestions[4].answer=='Aumentando'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:4,answer:'Aumentando', score:['De 5 a 15 años','Más de 15 años'].includes(expertiseQuestions[3].answer)?2:4, max: 4}))}> Aumentando</Button>
                  <Button className={`answer ${expertiseQuestions[4].answer=='Disminuyendo'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:4,answer:'Disminuyendo', score:['De 5 a 15 años','Más de 15 años'].includes(expertiseQuestions[3].answer)?4:2, max: 4}))}> Disminuyendo</Button>  
                  </div>
              </div>
              <div>
                  <h3 className="question">P: ¿Cuántos ingenieros de campo tiene?</h3>
                  <div className="answers short_answers">
                  <Button className={`answer ${expertiseQuestions[5].answer=='0 (totalmente subcontratado)'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'0 (totalmente subcontratado)', score:calcYield(1), max:3 }))}>  0 (totalmente subcontratado)</Button>
                  <Button className={`answer ${expertiseQuestions[5].answer=='De 1 a 10'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'De 1 a 10', score:calcYield(5), max:3 }))}> De 1 a 10</Button>
                  <Button className={`answer ${expertiseQuestions[5].answer=='De 11 a 50'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'De 11 a 50', score:calcYield(30), max:3 }))}> De 11 a 50</Button>
                  <Button className={`answer ${expertiseQuestions[5].answer=='De 50 a 100'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'De 50 a 100', score:calcYield(75), max:3 }))}>De 50 a 100</Button>   
                  <Button className={`answer ${expertiseQuestions[5].answer=='Más de 100'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'Más de 100', score:calcYield(500), max:3 }))}>Más de 100</Button>   
                  </div>
              </div>
              
              <div className="page_nav">
              <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Anterior</span></Button>
              <Button className="next_button" component={ Link } to={'/cost'}><span>Siguiente</span><ArrowForwardIos /></Button>
              </div>
              <div>
                  <Button component={Link} to='/results' className="next_button view_results">Ver los resultados de la sección</Button>
              </div>
            </div>
          )}
        </div>
      </div>
      {page === 2 && (
          <SlideOut title={personnelChallenges.title} copy={personnelChallenges.copy}  bullets={personnelChallenges.bullets}/>
          )}
          {page === 3 && (
            <SlideOut title={increaseExperience.title} copy={increaseExperience.copy} stat={increaseExperience.stat}/>
            )}
      <SideNav />
    </div>
    </Container>
  );
};

export default Expertise;